import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { LoginComponent } from './login/login.component';
import { FiltersComponent } from './filters/filters.component';
import { SignComponent } from './sign/sign.component';
import { DriverSignerComponent } from './driver-signer/driver-signer.component';
import {
  AuthGuardGuard as AuthGuard
} from './_services/auth-guard.guard';
import {
  NoAuthGuard 
} from './_services/no-auth.guard';


const routes: Routes = [
  { path: "", component: LoginComponent, pathMatch: 'full', canActivate: [NoAuthGuard], data: { showHeader: false } },
  { path: "login", component: LoginComponent, pathMatch: 'full', canActivate: [NoAuthGuard], data: { showHeader: false } },
  { path: "home", component: HomeComponent, pathMatch: 'full', canActivate: [AuthGuard], data: { showHeader: true }},
  { path: "searchresults", component: SearchComponent, pathMatch: 'full', canActivate: [AuthGuard], data: { showHeader: true }},
  { path: "search", component: FiltersComponent, pathMatch: 'full', canActivate: [AuthGuard], data: { showHeader: true }},
  { path: "sign", component: SignComponent, pathMatch: 'full', canActivate: [AuthGuard], data: { showHeader: true }},
  { path: "ds/:guid", component: DriverSignerComponent, pathMatch: 'full', data: { showDriverHeader: true }},
  { path: '**', redirectTo: '', canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
